import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'SidebarIcon',
  viewBox: '0 0 16 16',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1 5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm5.5-1.5h5.167c1.012 0 1.833.82 1.833 1.833v5.334c0 1.012-.82 1.833-1.833 1.833H6.5zm-2.167 0H5v9h-.667A1.833 1.833 0 0 1 2.5 10.667V5.333c0-1.012.82-1.833 1.833-1.833"
        clipRule="evenodd"
      />
    </svg>
  ),
});
